import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tbottom: ", ";\n\tcolor: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n\tposition: relative;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tcolor: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: block;\n\tcolor: ", ";\n\tfont-size: ", ";\n\tmargin: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tfont-size: ", ";\n\tcolor: ", ";\n\tmargin: 0;\n\tpadding: 0 ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: 100%;\n\tposition: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { styled } from '../../theme-provider';
import { Text, TextAppearance, TextColor } from '../../text';
import { getLabelIconColor, getStatusColor } from '../utils';
import { TextAreaAppearance, TextInputAppearance } from '../shared';
var StyledLabel = styled.label.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-ou9hf4"
})(_templateObject());
var StyledLabelText = styled.p.withConfig({
  displayName: "StyledLabelText",
  componentId: "sc-142ibbk"
})(_templateObject2(), function (props) {
  return props.theme.textAppearances.copy0100.fontSize;
}, getLabelIconColor, function (props) {
  return props.hasIcon ? props.theme.size.static400 : 0;
});
var AdditionalInfo = styled.div.withConfig({
  displayName: "AdditionalInfo",
  componentId: "sc-lvik59"
})(_templateObject3(), function (props) {
  return props.errorShouldBeVisible ? 'space-between' : 'flex-end';
});
var StyledErrorText = styled.p.withConfig({
  displayName: "StyledErrorText",
  componentId: "sc-dc2yhs"
})(_templateObject4(), function (props) {
  return props.theme.interaction.recipe360.default;
}, function (props) {
  return props.theme.textAppearances.copy0100.fontSize;
});
var StyledCharacterCounterWrapper = styled.span.withConfig({
  displayName: "StyledCharacterCounterWrapper",
  componentId: "sc-fsxjbb"
})(_templateObject5(), getStatusColor);
var StyledContainer = styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-jnlhjm"
})(_templateObject6());
var StyledIcon = styled.div.withConfig({
  displayName: "StyledIcon",
  componentId: "sc-fo1bds"
})(_templateObject7(), function (props) {
  return props.theme.size.static200;
}, getLabelIconColor);

var CharacterCounter = function CharacterCounter(_ref) {
  var maxLength = _ref.maxLength,
      appearance = _ref.appearance,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value;
  return React.createElement(StyledCharacterCounterWrapper, {
    "aria-hidden": true,
    appearance: appearance
  }, React.createElement(Text, {
    color: TextColor.inherit,
    appearance: TextAppearance.copy100
  }, value.length, "/", maxLength));
};

export var TextFieldWrapper = function TextFieldWrapper(props) {
  var additionalFeedback = props.additionalFeedback,
      appearance = props.appearance,
      children = props.children,
      errorText = props.errorText,
      label = props.label,
      maxLength = props.maxLength,
      required = props.required,
      value = props.value,
      icon = props.icon;
  var errorShouldBeVisible = Boolean((appearance === TextAreaAppearance.Error || appearance === TextInputAppearance.Error) && errorText);
  var additionalInfoShouldBeVisible = errorShouldBeVisible || maxLength;
  return React.createElement(StyledLabel, null, React.createElement(StyledLabelText, {
    appearance: appearance,
    hasIcon: Boolean(icon)
  }, label, required && '*'), icon ? React.createElement(StyledContainer, null, React.createElement(StyledIcon, {
    appearance: appearance
  }, icon), React.createElement(React.Fragment, null, children)) : React.createElement(React.Fragment, null, children), additionalInfoShouldBeVisible && React.createElement(AdditionalInfo, {
    errorShouldBeVisible: errorShouldBeVisible
  }, errorShouldBeVisible && React.createElement(StyledErrorText, {
    "aria-live": "assertive",
    "aria-relevant": "all"
  }, errorText), maxLength && React.createElement(CharacterCounter, {
    appearance: appearance,
    value: value,
    maxLength: maxLength
  })), additionalFeedback);
};
TextFieldWrapper.displayName = 'TextFieldWrapper';